/** @jsxRuntime classic */
/** @jsxFrag React.Fragment */
/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Card } from '@bonitour/components'
import { wrapperTotal } from './TotalPriceDisplay.styles'
import { formatMoney } from '@bonitour/common-functions'

export const TotalPriceDisplay = ({ totalPrice }) => {
  return (
    <Card customCss={[wrapperTotal]}>
      <p className='total__label'>Total</p>
      <p className='total__number'>
        {formatMoney(totalPrice)}
      </p>
    </Card>
  )
}
